import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateDirective,TranslatePipe } from '@ngx-translate/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { QRCodeComponent } from 'angularx-qrcode';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DragFileBrowseUIComponent } from '../drag-file-browse-ui/drag-file-browse-ui.component';
import { WidgetEditDialogComponent } from '../widgets/widget-edit-dialog/widget-edit-dialog.component';
import { ProductRegistrationEditFormComponent } from '../widgets/edit-dialog/product-registration-edit-form/product-registration-edit-form.component';
import { FormEditFormComponent } from '../widgets/edit-dialog/form-edit-form/form-edit-form.component';
import { ComposedEditFormComponent } from '../widgets/edit-dialog/composed-edit-form/composed-edit-form.component';
import { AnnotatedmapAnnotationDialogComponent } from '../widgets/edit-dialog/annotatedmap-annotation-dialog/annotatedmap-annotation-dialog.component';
import { AnnotatedmapAnnotationDynamicDialogComponent } from '../widgets/edit-dialog/annotatedmap-annotation-dynamic-dialog/annotatedmap-annotation-dynamic-dialog.component';
import { AnnotatedmapEditFormComponent } from '../widgets/edit-dialog/annotatedmap-edit-form/annotatedmap-edit-form.component';
import { BillboardImgEditFormComponent } from '../widgets/edit-dialog/billboard-img-edit-form/billboard-img-edit-form.component';
import { BillboardVdEditFormComponent } from '../widgets/edit-dialog/billboard-vd-edit-form/billboard-vd-edit-form.component';
import { ButtonsEditFormComponent } from '../widgets/edit-dialog/buttons-edit-form/buttons-edit-form.component';
import { CalltoactionEditFormComponent } from '../widgets/edit-dialog/calltoaction-edit-form/calltoaction-edit-form.component';
import { CountdownEditFormComponent } from '../widgets/edit-dialog/countdown-edit-form/countdown-edit-form.component';
import { ImageEditFormComponent } from '../widgets/edit-dialog/image-edit-form/image-edit-form.component';
import { ImagesEditFormComponent } from '../widgets/edit-dialog/images-edit-form/images-edit-form.component';
import { SplashVideoEditFormComponent } from '../widgets/edit-dialog/splash-video-edit-form/splash-video-edit-form.component';
import { TextEditFormComponent } from '../widgets/edit-dialog/text-edit-form/text-edit-form.component';
import { VideoEditFormComponent } from '../widgets/edit-dialog/video-edit-form/video-edit-form.component';
import { VideosEditFormComponent } from '../widgets/edit-dialog/videos-edit-form/videos-edit-form.component';
import { FormEditFieldOptionsDialogComponent } from '../widgets/editWidgets/form-edit-field-options-dialog/form-edit-field-options-dialog.component';

import { VgCoreModule } from '@videogular/ngx-videogular/core';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';

import { WidgetStylingComponent } from '../widgets/editWidgets/widget-styling/widget-styling.component';
import { WidgetEditFiltersComponent } from '../widgets/editWidgets/widget-edit-filters/widget-edit-filters.component';
import { WidgetEditFiltersEditDialogComponent } from '../widgets/editWidgets/widget-edit-filters-edit-dialog/widget-edit-filters-edit-dialog.component';
import { SpacerEditComponent } from '../widgets/editWidgets/spacer-edit/spacer-edit.component';
import { ChatEditComponent } from '../widgets/editWidgets/chat-edit/chat-edit.component';
import { ListEditComponent } from '../widgets/editWidgets/list-edit/list-edit.component';
import { OneclickpayEditComponent } from '../widgets/editWidgets/oneclickpay-edit/oneclickpay-edit.component';
import { ProductsEditComponent } from '../widgets/editWidgets/products-edit/products-edit.component';
import { OneclikpayItemDialogComponent } from '../widgets/editWidgets/oneclikpay-item-dialog/oneclikpay-item-dialog.component';
import { Model3dEditComponent } from '../widgets/editWidgets/model3d-edit/model3d-edit.component';
import { FormEditFieldDialogComponent } from '../widgets/editWidgets/form-edit-field-dialog/form-edit-field-dialog.component';
import { MatOptionModule, MatRippleModule } from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio';
import { ComposedEditContentDialogComponent } from '../widgets/editWidgets/composed-edit-content-dialog/composed-edit-content-dialog.component';
import { MediaDetailsDialogComponent } from '../widgets/edit-dialog/media-details-dialog/media-details-dialog.component';
import { NgxColorsModule } from 'ngx-colors';
import { PreviewNoSubmitDirective } from './preview-no-submit.directive';
import { MatDialogModule } from '@angular/material/dialog';
import { MatTabsModule } from '@angular/material/tabs';
import { MapAdvancedMarkersComponent } from '../map-advanced-markers/map-advanced-markers.component';
import { MapAdvancedMarkersHorizontalComponent } from '../map-advanced-markers-horizontal/map-advanced-markers-horizontal.component';
import { LocationPickerComponent } from '../location-picker/location-picker.component';
import { UsersEditDialogComponent } from '../users/users-edit-dialog/users-edit-dialog.component';
import { MatChipsModule } from '@angular/material/chips';
import { UserGroupEditDialogComponent } from '../users/user-group-edit-dialog/user-group-edit-dialog.component';
import { QuillModule } from 'ngx-quill';
import { CreateUserDialogComponent } from '../users/create-user-dialog/create-user-dialog.component';
import { ManageUsersUsergroupsComponent } from '../users/manage-users-usergroups/manage-users-usergroups.component';
import { WorkTaskTemplateFieldRulesComponent } from '../worktask/work-task-template-field-rules/work-task-template-field-rules.component';
import { TridysItemTreeDataComponent } from '../tridy/tridys-item-tree-data/tridys-item-tree-data.component';
import { ErrorDialogComponent } from '../error-dialog/error-dialog.component';
import { UpdateConfirmationDialogComponent } from '../update-confirmation-dialog/update-confirmation-dialog.component';
import { TridyDetailsDialogComponent } from '../tridy/tridy-details-dialog/tridy-details-dialog.component';
import { TridysItemComponent } from '../tridy/tridys-item/tridys-item.component';
import { SettingsDialogComponent } from '../settings-dialog/settings-dialog.component';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TridyIcomingOutgoingDataCardComponent } from '../reports/tridy-icoming-outgoing-data-card/tridy-icoming-outgoing-data-card.component';
import { ReportsItemTridyDialogComponent } from '../reports/reports-item-tridy-dialog/reports-item-tridy-dialog.component';
import { ReportFilterSettingsDialogComponent } from '../reports/report-filter-settings-dialog/report-filter-settings-dialog.component';
import { ReportsListComponent } from '../reports/reports-list/reports-list.component';
import { DuplicateReportTemplateDialogComponent } from '../duplicate-report-template-dialog/duplicate-report-template-dialog.component';
import { ReportAddFilterFieldDialogComponent } from '../reports/report-add-filter-field-dialog/report-add-filter-field-dialog.component';
import { ReportCreateDialogComponent } from '../reports/report-create-dialog/report-create-dialog.component';
import { QrCodeDialogComponent } from '../qr-code-dialog/qr-code-dialog.component';
import { DPPTemplateListComponent } from '../dpp-template-list/dpp-template-list.component';
import { ProductsComponent } from '../products/products.component';
import { ProductsItemComponent } from '../products-item/products-item.component';
import { PlaceholderListComponent } from '../placeholder-list/placeholder-list.component';
import { MatTableModule } from '@angular/material/table';
import { RouterModule } from '@angular/router';
import { FinishedTasksItemComponent } from '../finished-tasks/finished-tasks-item/finished-tasks-item.component';
import { FinishedTasksMapComponent } from '../finished-tasks/finished-tasks-map/finished-tasks-map.component';
import { FinishedTasksComponent } from '../finished-tasks/finished-tasks.component';
import { TridyBulkImportDialogComponent } from '../tridy/tridy-bulk-import-dialog/tridy-bulk-import-dialog.component';
import { GenerateTridysComponent } from '../tridy/generate-tridys/generate-tridys.component';
import { UpdateTridysComponent } from '../tridy/update-tridys/update-tridys.component';
import { TridysComponent } from '../tridy/tridys/tridys.component';
import { TridyQrExportDialogComponent } from '../tridy/tridy-qr-export-dialog/tridy-qr-export-dialog.component';
import { GooglemapComponent } from '../googlemap/googlemap.component';
import { MapMarkerEditComponent } from '../map-marker-edit/map-marker-edit.component';
import { MapMarkerComponent } from '../map-marker/map-marker.component';
import { InterfacesCreateTokenDialogComponent } from '../interfaces-create-token-dialog/interfaces-create-token-dialog.component';
import { InterfacesDataDialogComponent } from '../interfaces-data-dialog/interfaces-data-dialog.component';
import { InterfacesDataMappingDialogComponent } from '../interfaces-data-mapping-dialog/interfaces-data-mapping-dialog.component';
import { InterfacesListComponent } from '../interfaces-list/interfaces-list.component';
import { MediaDeleteConfirmDialogComponent } from '../media/media-delete-confirm-dialog/media-delete-confirm-dialog.component';
import { MediaDialogContentComponent } from '../media/media-dialog-content/media-dialog-content.component';
import { MediaDialogHandlerComponent } from '../media/media-dialog-handler/media-dialog-handler.component';
import { MediaFolderContentComponent } from '../media/media-folder-content/media-folder-content.component';
import { MediaFolderComponent } from '../media/media-folder/media-folder.component';
import { MediaHandlerComponent } from '../media/media-handler/media-handler.component';
import { MediaPreviewDialogComponent } from '../media/media-preview-dialog/media-preview-dialog.component';
import { ReportsItemTridysListAggridComponent } from '../reports/reports-item-tridys-list-aggrid/reports-item-tridys-list-aggrid.component';
import { AgGridAngular, AgGridModule } from 'ag-grid-angular';
import { FitGridToViewportDirective } from './fit-grid-to-viewport.directive';
import { PassTemplatesComponent } from '../pass-template/pass-templates/pass-templates.component';
import { PassTemplatesSettingsEditComponent } from '../pass-template/pass-templates-settings-edit/pass-templates-settings-edit.component';
import { PassTemplatesTranslationsComponent } from '../pass-template/pass-templates-translations/pass-templates-translations.component';
import { PassTemplatesThemeEditComponent } from '../pass-template/pass-templates-theme-edit/pass-templates-theme-edit.component';
import { DuplicatePassTemplateDialogComponent } from '../duplicate-pass-template-dialog/duplicate-pass-template-dialog.component';
import { LanguageVisualisationDialogComponent } from '../language-visualisation-dialog/language-visualisation-dialog.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { TaskTemplateFieldNewOptionDialogComponent } from '../worktask/worktask-template-field-new-option-dialog/worktask-template-field-new-option-dialog.component';
import { WorkTaskTemplateAdvancedDialogComponent } from '../worktask/work-task-template-advanced-dialog/work-task-template-advanced-dialog.component';
import { WorkTaskTemplateDialogIncomingOutgoingComponent } from '../worktask/work-task-template-dialog-incoming-outgoing/work-task-template-dialog-incoming-outgoing.component';
import { WorkTaskTemplateDialogComponent } from '../worktask/work-task-template-dialog/work-task-template-dialog.component';
import { WorkTaskTemplateEditValueDialogComponent } from '../worktask/work-task-template-edit-value-dialog/work-task-template-edit-value-dialog.component';
import { WorkTaskTemplateFieldRuleDialogComponent } from '../worktask/work-task-template-field-rule-dialog/work-task-template-field-rule-dialog.component';
import { WorkTaskTemplateFilterDialogComponent } from '../worktask/work-task-template-filter-dialog/work-task-template-filter-dialog.component';
import { WorkTaskTemplateFiltersComponent } from '../worktask/work-task-template-filters/work-task-template-filters.component';
import { WorkTaskTemplateWorkflowDialogComponent } from '../worktask/work-task-template-workflow-dialog/work-task-template-workflow-dialog.component';
import { TaskTemplateCreateDialogComponent } from '../worktask/worktask-template-create-dialog/worktask-template-create-dialog.component';
import { TaskTemplateEditSectionDialogComponent } from '../worktask/worktask-template-edit-section-dialog/worktask-template-edit-section-dialog.component';
import { TaskTemplateFieldDialogComponent } from '../worktask/worktask-template-field-dialog/worktask-template-field-dialog.component';
import { TaskTemplatesGroupsDialogComponent } from '../worktask/worktask-templates-groups-dialog/worktask-templates-groups-dialog.component';
import { TaskTemplatesGroupsComponent } from '../worktask/worktask-templates-groups/worktask-templates-groups.component';
import { TaskTemplateImportFieldEditDialogComponent } from '../worktask/worktask-template-import-field-edit-dialog/worktask-template-import-field-edit-dialog.component';
import { TaskTemplateItemComponent } from '../worktask/worktask-template-item/worktask-template-item.component';
import { TaskTemplatesComponent } from '../worktask/worktask-templates/worktask-templates.component';
import { MapMarkerHorizontalComponent } from '../map-marker-horizontal/map-marker-horizontal.component';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { DragAndDropDirective } from '../directive/drag-and-drop.directive';
import { ContentTypeDisplayTemplateDialogComponent } from '../content-type/content-type-display-template-dialog/content-type-display-template-dialog.component';
import { ContentTypeDisplayTemplateFieldDialogComponent } from '../content-type/content-type-display-template-field-dialog/content-type-display-template-field-dialog.component';
import { ContentTypeSettingsDialogComponent } from '../content-type/content-type-settings-dialog/content-type-settings-dialog.component';
import { ContentTypesSchemaPropertiesDialogComponent } from '../content-type/content-types-schema-properties-dialog/content-types-schema-properties-dialog.component';
import { ContentTypesSchemaValidatorDialogComponent } from '../content-type/content-types-schema-validator-dialog/content-types-schema-validator-dialog.component';
import { ContentTypesSchemaViewDialogComponent } from '../content-type/content-types-schema-view-dialog/content-types-schema-view-dialog.component';
import { SchemaMetaFormComponent } from '../content-type/schema-meta-form/schema-meta-form.component';
import { DeleteContentTypesDialogComponent } from '../delete-content-types-dialog/delete-content-types-dialog.component';
import { CoverImageDialogComponent } from '../cover-image-dialog/cover-image-dialog.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

import {
  DEFAULT_WIDGET_REGISTRY,
  ReaderDocument,
  ReaderShellComponent,
  WIDGET_REGISTRY,
} from '@narravero/web-reader-lib';
import { InfoMesageDialogComponent } from '../info-mesage-dialog/info-mesage-dialog.component';

@NgModule({
  declarations: [
    DragFileBrowseUIComponent,
    WidgetEditDialogComponent,
    ProductRegistrationEditFormComponent,
    FormEditFormComponent,
    ComposedEditFormComponent,
    FormEditFieldOptionsDialogComponent,
    BillboardImgEditFormComponent,
    CalltoactionEditFormComponent,
    ImageEditFormComponent,
    BillboardVdEditFormComponent,
    SplashVideoEditFormComponent,
    TextEditFormComponent,
    VideoEditFormComponent,
    ImagesEditFormComponent,
    ButtonsEditFormComponent,
    CountdownEditFormComponent,
    AnnotatedmapEditFormComponent,
    AnnotatedmapAnnotationDialogComponent,
    AnnotatedmapAnnotationDynamicDialogComponent,
    VideosEditFormComponent,
    WidgetStylingComponent,
    WidgetEditFiltersComponent,
    WidgetEditFiltersEditDialogComponent,
    SpacerEditComponent,
    ProductsEditComponent,
    ChatEditComponent,
    ListEditComponent,
    OneclickpayEditComponent,
    OneclikpayItemDialogComponent,
    Model3dEditComponent,
    FormEditFieldDialogComponent,
    ComposedEditContentDialogComponent,

    MediaDetailsDialogComponent,
    MediaFolderComponent,
    MediaPreviewDialogComponent,
    MediaHandlerComponent,
    MediaFolderContentComponent,
    MediaDialogHandlerComponent,
    MediaDialogContentComponent,
    MediaDeleteConfirmDialogComponent,
    
    MapAdvancedMarkersComponent,
    MapAdvancedMarkersHorizontalComponent,
    LocationPickerComponent,
    UsersEditDialogComponent,
    UserGroupEditDialogComponent,
    CreateUserDialogComponent,
    ManageUsersUsergroupsComponent,
    WorkTaskTemplateFieldRulesComponent,
    TridysItemTreeDataComponent,
    UpdateConfirmationDialogComponent,
    ErrorDialogComponent,
    TridyDetailsDialogComponent,
    TridysItemComponent,
    SettingsDialogComponent,
    TridyIcomingOutgoingDataCardComponent,

    ReportsItemTridyDialogComponent,
    ReportFilterSettingsDialogComponent,
    ReportsListComponent,
    ReportCreateDialogComponent,
    ReportAddFilterFieldDialogComponent,
    ReportsItemTridysListAggridComponent,
    DuplicateReportTemplateDialogComponent,
    QrCodeDialogComponent,
    DPPTemplateListComponent,

    ProductsComponent,
    ProductsItemComponent,

    PlaceholderListComponent,

    FinishedTasksItemComponent,
    FinishedTasksMapComponent,
    FinishedTasksComponent,

    TridyBulkImportDialogComponent,
    GenerateTridysComponent,
    UpdateTridysComponent,
    TridysComponent,
    TridyQrExportDialogComponent,

    GooglemapComponent,
    MapMarkerComponent,
    MapMarkerEditComponent,
    MapMarkerHorizontalComponent,

    InterfacesListComponent,
    InterfacesDataDialogComponent,
    InterfacesDataMappingDialogComponent,
    InterfacesCreateTokenDialogComponent,

    PassTemplatesComponent,
    PassTemplatesThemeEditComponent,
    PassTemplatesSettingsEditComponent,
    PassTemplatesTranslationsComponent,
    DuplicatePassTemplateDialogComponent,

    DeleteContentTypesDialogComponent,
    ContentTypesSchemaPropertiesDialogComponent,
    ContentTypeSettingsDialogComponent,
    ContentTypesSchemaViewDialogComponent,
    ContentTypesSchemaValidatorDialogComponent,
    ContentTypeDisplayTemplateDialogComponent,
    ContentTypeDisplayTemplateFieldDialogComponent,
    CoverImageDialogComponent,

    LanguageVisualisationDialogComponent,

    TaskTemplateFieldNewOptionDialogComponent,
    WorkTaskTemplateAdvancedDialogComponent,
    WorkTaskTemplateDialogComponent,
    WorkTaskTemplateDialogIncomingOutgoingComponent,
    WorkTaskTemplateEditValueDialogComponent,
    WorkTaskTemplateFieldRuleDialogComponent,
    WorkTaskTemplateFilterDialogComponent,
    WorkTaskTemplateFiltersComponent,
    WorkTaskTemplateWorkflowDialogComponent,
    TaskTemplateCreateDialogComponent,
    TaskTemplateEditSectionDialogComponent,
    TaskTemplateFieldDialogComponent,
    TaskTemplatesGroupsComponent,
    TaskTemplatesGroupsDialogComponent,
    TaskTemplatesComponent,
    TaskTemplateItemComponent,
    TaskTemplateImportFieldEditDialogComponent,
    DragAndDropDirective,
    InfoMesageDialogComponent

  ],
  imports: [
    ReaderShellComponent,
    CommonModule,
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    DragDropModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatCardModule,
    MatSortModule,
    MatExpansionModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatTreeModule,
    MatInputModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    MatRippleModule,
    MatRadioModule,
    NgxColorsModule,
    MatDialogModule,
    MatTabsModule,
    MatChipsModule,
    QuillModule,
    ClipboardModule,
    MatTableModule,
    QRCodeComponent,
    AgGridModule,
    FitGridToViewportDirective,
    MatOptionModule,
    MatSlideToggleModule,
    GoogleMapsModule,
    MatProgressBarModule,
    NgxMatSelectSearchModule,
    SchemaMetaFormComponent,
    PreviewNoSubmitDirective,
    TranslateDirective,
    TranslatePipe
  ],
  exports:[
    RouterModule,
    MatMenuModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatToolbarModule,
    MatIconModule,
    MatDividerModule,
    MatListModule,
    MatTooltipModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    DragDropModule,
    MatDatepickerModule,
    MatPaginatorModule,
    MatCardModule,
    MatSortModule,
    MatSelectModule,
    MatExpansionModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatTreeModule,
    MatInputModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    MatRippleModule,
    MatRadioModule,
    MatTableModule,
    AgGridModule,
    FitGridToViewportDirective,
    QuillModule,
    ClipboardModule,
    QRCodeComponent,
    MatOptionModule,
    MatSlideToggleModule,
    GoogleMapsModule,
    MatDialogModule,
    MatTabsModule,
    MatChipsModule,
    MatProgressBarModule,
    NgxMatSelectSearchModule,
    DragAndDropDirective,
    DragFileBrowseUIComponent,
    WidgetEditDialogComponent,
    ProductRegistrationEditFormComponent,
    FormEditFormComponent,
    ComposedEditFormComponent,
    FormEditFieldOptionsDialogComponent,
    InfoMesageDialogComponent,
    BillboardImgEditFormComponent,
    CalltoactionEditFormComponent,
    ImageEditFormComponent,
    BillboardVdEditFormComponent,
    SplashVideoEditFormComponent,
    TextEditFormComponent,
    VideoEditFormComponent,
    ImagesEditFormComponent,
    ButtonsEditFormComponent,
    CountdownEditFormComponent,
    AnnotatedmapEditFormComponent,
    AnnotatedmapAnnotationDialogComponent,
    AnnotatedmapAnnotationDynamicDialogComponent,
    VideosEditFormComponent,
    WidgetStylingComponent,
    WidgetEditFiltersComponent,
    WidgetEditFiltersEditDialogComponent,
    SpacerEditComponent,
    ProductsEditComponent,
    ChatEditComponent,
    ListEditComponent,
    OneclickpayEditComponent,
    OneclikpayItemDialogComponent,
    Model3dEditComponent,
    FormEditFieldDialogComponent,
    ComposedEditContentDialogComponent,
    MediaDetailsDialogComponent,
    MediaFolderComponent,
    MediaPreviewDialogComponent,
    MediaHandlerComponent,
    MediaFolderContentComponent,
    MediaDialogHandlerComponent,
    MediaDialogContentComponent,
    MediaDeleteConfirmDialogComponent,

    MapAdvancedMarkersComponent,
    MapAdvancedMarkersHorizontalComponent,
    LocationPickerComponent,
    UsersEditDialogComponent,
    UserGroupEditDialogComponent,
    CreateUserDialogComponent,
    ManageUsersUsergroupsComponent,
    WorkTaskTemplateFieldRulesComponent,
    TridysItemTreeDataComponent,
    UpdateConfirmationDialogComponent,
    ErrorDialogComponent,
    TridyDetailsDialogComponent,
    TridysItemComponent,
    SettingsDialogComponent,
    TridyIcomingOutgoingDataCardComponent,
    ReportsItemTridyDialogComponent,
    ReportFilterSettingsDialogComponent,
    ReportsListComponent,
    ReportCreateDialogComponent,
    ReportAddFilterFieldDialogComponent,
    ReportsItemTridysListAggridComponent,
    DuplicateReportTemplateDialogComponent,
    QrCodeDialogComponent,
    DPPTemplateListComponent,

    ProductsComponent,
    ProductsItemComponent,

    PlaceholderListComponent,
    FinishedTasksItemComponent,
    FinishedTasksMapComponent,
    FinishedTasksComponent,

    TridyBulkImportDialogComponent,
    GenerateTridysComponent,
    UpdateTridysComponent,
    TridysComponent,
    TridyQrExportDialogComponent,

    GooglemapComponent,
    MapMarkerComponent,
    MapMarkerEditComponent,
    MapMarkerHorizontalComponent,

    InterfacesListComponent,
    InterfacesDataDialogComponent,
    InterfacesDataMappingDialogComponent,
    InterfacesCreateTokenDialogComponent,
    
    PassTemplatesComponent,
    PassTemplatesThemeEditComponent,
    PassTemplatesSettingsEditComponent,
    PassTemplatesTranslationsComponent,
    DuplicatePassTemplateDialogComponent,

    DeleteContentTypesDialogComponent,
    ContentTypesSchemaPropertiesDialogComponent,
    ContentTypeSettingsDialogComponent,
    ContentTypesSchemaViewDialogComponent,
    ContentTypesSchemaValidatorDialogComponent,
    ContentTypeDisplayTemplateDialogComponent,
    ContentTypeDisplayTemplateFieldDialogComponent,
    CoverImageDialogComponent,

    LanguageVisualisationDialogComponent,

    TaskTemplateFieldNewOptionDialogComponent,
    WorkTaskTemplateAdvancedDialogComponent,
    WorkTaskTemplateDialogComponent,
    WorkTaskTemplateDialogIncomingOutgoingComponent,
    WorkTaskTemplateEditValueDialogComponent,
    WorkTaskTemplateFieldRuleDialogComponent,
    WorkTaskTemplateFilterDialogComponent,
    WorkTaskTemplateFiltersComponent,
    WorkTaskTemplateWorkflowDialogComponent,
    TaskTemplateCreateDialogComponent,
    TaskTemplateEditSectionDialogComponent,
    TaskTemplateFieldDialogComponent,
    TaskTemplatesGroupsComponent,
    TaskTemplatesGroupsDialogComponent,
    TaskTemplatesComponent,
    TaskTemplateItemComponent,
    TaskTemplateImportFieldEditDialogComponent,
    TranslateDirective,
    TranslatePipe
  ],
  providers: [
    {
      provide: WIDGET_REGISTRY,
      useValue: DEFAULT_WIDGET_REGISTRY,
    },
  ],
})
export class SharedModule { }
